module.exports = __webpack_public_path__ + "img/people-36-min.50b1acb1.png";